import { Route, Routes, Navigate } from "react-router-dom";
import { isEmpty } from "lodash";

import AuthLayout from "../../layouts/AuthLayout/AuthLayout";
import AuthContext from "../../context/AuthContext/AuthContext";
import LogInAuth from "../../pages/Auth/LogInAuth/LogInAuth";
import RegisterAuth from "../../pages/Auth/RegisterAuth/RegisterAuth";
import ConfirmRegisterAuth from "../../pages/Auth/ConfirmRegisterAuth/ConfirmRegisterAuth";
import LogOutAuth from "../../pages/Auth/LogOutAuth/LogOutAuth";
import ForgetPasswordAuth from "../../pages/Auth/ForgetPasswordAuth/ForgetPasswordAuth";
import NotFoundPage from "../../pages/Page/NotFoundPage/NotFoundPage";
import { decodeJWT, getCookies } from "../../utils";
import { convertRoleToPath } from "../../utils/enum";
import LogInOTPAuth from "../../pages/Auth/LogInOTPAuth/LogInOTPAuth";

const AuthContainer = () => {
  const accessToken = getCookies("accessToken");

  const isLogin = !isEmpty(accessToken);
  const decodedToken = decodeJWT(accessToken);

  const redirectUrl = `/${convertRoleToPath(decodedToken?.role)}`;

  return (
    <AuthLayout>
      <AuthContext>
        <Routes>
          {/* Log In */}
          <Route
            index
            path="/login"
            element={isLogin ? <Navigate to={redirectUrl} /> : <LogInAuth />}
          />
          {/* Log In OTP */}
          <Route
            index
            path="/login/otp"
            element={isLogin ? <Navigate to={redirectUrl} /> : <LogInOTPAuth />}
          />
          {/* Register */}
          {["/register", "/register/courier"].map((_item) => (
            <Route
              key={_item}
              path={_item}
              element={
                isLogin ? <Navigate to={redirectUrl} /> : <RegisterAuth />
              }
            />
          ))}
          {/* Register */}
          <Route
            index
            path="/register/confirm"
            element={
              isLogin ? <Navigate to={redirectUrl} /> : <ConfirmRegisterAuth />
            }
          />
          {/* Forget Password */}
          <Route
            path="/forget-password"
            element={
              isLogin ? <Navigate to={redirectUrl} /> : <ForgetPasswordAuth />
            }
          />
          {/* Log Out */}
          <Route path="/logout" element={<LogOutAuth />} />
          {/* Not Found */}
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </AuthContext>
    </AuthLayout>
  );
};

export default AuthContainer;
